/*! (c) Softem | MIT license */
import { Command } from "./Command";
/**
 * APIの認証を伴うコマンド情報を管理します。
 */
export class AuthorizationCommand extends Command {
    /**
     * このクラスの新しいインスタンスを初期化します。
     * @param method - HTTPメソッド（GET, POSTなど）
     * @param url - APIリクエストのURL
     * @param apiKey - APIの認証に使用するキー
     */
    constructor(method, url, apiKey) {
        super(method, url);
        // リクエストの認証ヘッダーを設定
        this.configure = (config, data) => {
            if (config.headers) {
                config.headers.authorization = `Token ${apiKey}`;
            }
        };
    }
}
